import { Component } from '@angular/core';

@Component({
  selector: 'app-executive-summary',
  standalone: true,
  imports: [],
  templateUrl: './executive-summary.component.html',
  styleUrl: './executive-summary.component.scss'
})
export class ExecutiveSummaryComponent {

}
